/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_All_DayInputs */

const es_chat_tool_detail_all_day = /** @type {(inputs: Chat_Tool_Detail_All_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo el día`)
};

const en_chat_tool_detail_all_day = /** @type {(inputs: Chat_Tool_Detail_All_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All day`)
};

/**
* | output |
* | --- |
* | "All day" |
*
* @param {Chat_Tool_Detail_All_DayInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_all_day = /** @type {((inputs?: Chat_Tool_Detail_All_DayInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_All_DayInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_all_day(inputs)
	return en_chat_tool_detail_all_day(inputs)
});
export { chat_tool_detail_all_day as "chat.tool_detail.all_day" }